export default function removeUrlParameterPlaceholder(url) {
	return url.replace(/\/:.*$/, '');
}
